var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html, property, css, customElement } from 'lit-element';
import CSTStyles from '../../styles/cst-styles/cst-styles';
let CSTLoadingContainer = class CSTLoadingContainer extends LitElement {
    constructor() {
        super(...arguments);
        this.message = 'Loading..';
    }
    render() {
        return html `
      <loading-container>
        <small>${this.message}</small>
        <slot></slot>
      </loading-container>
    `;
    }
};
CSTLoadingContainer.styles = css `
    ${CSTStyles} :host {
      display: flex;
      flex: 1 1 auto;
      margin-top: 24px;
      flex-direction: column;
    }

    loading-container {
      display: flex;
      justify-content: center;
      align-items: center;
    }

    loading-container small {
      margin-right: 16px;
    }
  `;
__decorate([
    property({ type: String })
], CSTLoadingContainer.prototype, "message", void 0);
CSTLoadingContainer = __decorate([
    customElement('cst-loading-container')
], CSTLoadingContainer);
export default CSTLoadingContainer;
//# sourceMappingURL=cst-loading-container.js.map